module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv6-7257d8f1597d2626dc859650ccacadc6.jpg";